import { CircularProgress } from '@material-ui/core';
import { useSearchStatus } from '../../../../../hooks/useSearchStatus';
import styles from './style.module.css';
import noResultImg from '../../../../../assets/ic-search-not-found.svg';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { useGetFiltersList } from '../../../../../hooks/useGetFiltersList';
import { box_gray } from '../../../../../assets';
import Typography from '../../../../../design-system/lib/Typography';
import Button from '../../../../../design-system/lib/Button';
import { useDispatch } from 'react-redux';
import { SetSearchOrderListRegexLoading, SetSearchOrderListRegexRequested, SetSearchOrderListRegexText } from '../../../../../Redux/actions/actionNames';
import { UpdateOrdersStatistics } from '../../../../../utils/update-ordersStatistics';


export const SearchNoresult = ({stats}) => {
    let {  regexText, listNoResult , searchNoResult  ,loading , listLoading} = useSearchStatus()
    let { cursor, cursorSort, DateRange, selectedServices, selectedStatus, selectedVehicleType, isScheduled, changed, zones } = useGetFiltersList()
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();


    function hasAtleastOneStat(stats) {
        if(!stats){
            return false
        }

        let has = false ;
        for (const [key, value] of Object.entries(stats)) {
            

            if(Number(value) > 0){
                has = true
            }
          }
          return has
          
    }



    if((String(regexText).length == 0  )&& listNoResult && !listLoading && hasAtleastOneStat(stats)){
        return<div className={styles.searchNoResultContainer}> <CircularProgress size={18} style={{margin:"20px calc(50% - 14px)",float:'left',marginTop:"40px"}}/></div>

    }else if(String(regexText).length == 0 && listNoResult && listLoading){
        

        return<div className={styles.searchNoResultContainer}> <CircularProgress size={18} style={{margin:"20px calc(50% - 14px)",float:'left',marginTop:"40px"}}/></div>
    }else if((String(regexText).length > 0  ) && !loading && searchNoResult) {
        return <div className={styles.searchNoResultContainer}>
            <img src={box_gray} className={styles.searchNoResultImg}/>
            <Typography weight='Body_Middle_Semibold' text={t("Noresultfound")} style={{color:"#242424"}} /> 
            <Typography weight='Body_Small_Regular' text={t("Please check your keyword")} style={{color:"#242424" ,marginTop:"2px"}} /> 
            <Button size='Small' type='Primary' text={t("Clear search")} style={{ marginTop:"10px"}} onClick={()=>{
                        dispatch(SetSearchOrderListRegexText(""))
                        dispatch(SetSearchOrderListRegexRequested(false))
                        dispatch(SetSearchOrderListRegexLoading(false))
                        UpdateOrdersStatistics()
            }} />
        </div>
    }else if((String(regexText).length > 0 ) && searchNoResult && loading ){
    
        return<div className={styles.searchNoResultContainer}> <CircularProgress size={18} style={{margin:"20px calc(50% - 14px)",float:'left',marginTop:"40px"}}/></div>

    }else{
        return null
    }


};




